// Geometria da preview da slab. Fonte canônica é GET /admin/art-labels/geometry;
// DEFAULT_GEOMETRY só serve para renderizar enquanto a resposta não chega.
// Espelho de ART_LABEL_GEOMETRY do backend (slab CGC 1:1: holder 80,0 × 134,6 mm, janela 66 × 30 mm).
export const DEFAULT_GEOMETRY = {
    labelWidth: 66,
    frontHeight: 30,
    backHeight: 30,
    bleed: 2,
    safeInset: 3,
    cardTopGap: 1.5,
    cornerRadius: 1.5,
    slab: { width: 80, height: 134.6, labelTop: 5, cardBottomMargin: 3.5, cardWidth: 63, cardHeight: 88 },
    calibratedAt: null,
};

export const CARD_MM = { width: 63, height: 88 };

const rect = (x, y, width, height) => ({ x, y, width, height });

// Remove floating-point noise without rounding to integer
const clean = (v) => Math.round(v * 1e9) / 1e9;

/**
 * Canvas da etiqueta nos métodos ACE e nas correções (LABEL_CANVAS do backend): largura fixa e
 * altura pela proporção da frente com sangria — 1024 × 497 na geometria CGC.
 */
export function labelCanvas(geometry = DEFAULT_GEOMETRY, width = 1024) {
    const g = { ...DEFAULT_GEOMETRY, ...(geometry || {}) };
    return { width, height: Math.round((width * (g.frontHeight + 2 * g.bleed)) / (g.labelWidth + 2 * g.bleed)) };
}

export function cropRect(crop, cardRect) {
    const c = crop || { top: 0, bottom: 1, left: 0, right: 1 };
    return rect(
        clean(cardRect.x + c.left * cardRect.width),
        clean(cardRect.y + c.top * cardRect.height),
        clean((c.right - c.left) * cardRect.width),
        clean((c.bottom - c.top) * cardRect.height),
    );
}

const ERA_CROPS = {
    wotc: { top: 0.12, bottom: 0.50, left: 0.08, right: 0.92 },
    "ex-hgss": { top: 0.11, bottom: 0.49, left: 0.07, right: 0.93 },
    "bw-swsh": { top: 0.11, bottom: 0.47, left: 0.06, right: 0.78 },
    sv: { top: 0.11, bottom: 0.47, left: 0.06, right: 0.94 },
};

export const ERA_OPTIONS = [
    ["wotc", "WotC (1999–2003)"],
    ["ex-hgss", "EX a HGSS (2003–2011)"],
    ["bw-swsh", "BW a SWSH (2011–2022)"],
    ["sv", "SV / ME (2023–)"],
    ["unknown", "desconhecida"],
];

export function frameCropDefault(frameType, era = "sv") {
    if (frameType === "full_art") return { top: 0.12, bottom: 0.55, left: 0.04, right: 0.96 };
    return { ...(ERA_CROPS[era] || ERA_CROPS.sv) };
}
